import { useState, useEffect, useContext } from "react";
import { FaCogs, FaIdBadge, FaMoneyBillWave } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import { useCarriereEvents } from "contexts/CarriereEventsContext";
import Parametres from "components/app/AuditComplet/Retraite/Periode/Parametres";
import RevenusRetraite from "components/app/AuditComplet/Retraite/Periode/RevenusRetraite";
import PeriodeCumulEmploi from "./Periode cumul emploi";

const AjoutPeriodeCumulEmploiPageModal = (props) => {
  const [disableValidate, setDisableValidate] = useState(false);
  const context = useContext(AppContext);
  const { trackEvent } = useCarriereEvents();
  const [currentPage, setCurrentPage] = useState(1);

  const handleMenu = () => {

    let menu = [
      {
        isTitle: true,
        title: "Période",
        subTitle: "Période professionnelle",
      },
      {
        label: "Période",
        icon: <FaIdBadge />,
        content: <PeriodeCumulEmploi Outil="" ClientConjoint={props.ClientConjoint} visible={props.visible} />,
      },
      {
        label: "Revenus",
        icon: <FaMoneyBillWave />,
        content: <RevenusRetraite Outil="" />,
      },
      {
        label: "Paramètres",
        icon: <FaCogs />,
        content: <Parametres Outil="" ClientConjoint={props.ClientConjoint} />,
      },
    ];

    if (
      context.state.RetraiteActivite === "RsiArtisan" ||
      context.state.RetraiteActivite === "CnbfSalarie" ||
      context.state.RetraiteActivite === "Cavom" ||
      context.state.RetraiteActivite === "MicroRSI" ||
      context.state.RetraiteActivite === "MicroBIC" ||
      context.state.RetraiteActivite === "MicroBNC" ||
      context.state.RetraiteActivite === "MicroCipav" 
    ) {
      menu = menu.filter((k) => k.label !== "Paramètres");
    }

    return menu;
  };
  useEffect(() => {
    setCurrentPage(1);
  }, [props.visible]);

  const handleEndGreaterBegin = () => {
    let DebutPeriode = context.state.RetraiteDebutActivite;
    let FinPeriode = context.state.RetraiteFinActivite;
    if (DebutPeriode.length === 8 && FinPeriode.length === 8) {
      let AnneeDebutPeriode = DebutPeriode.slice(4);
      let MoisDebutPeriode = DebutPeriode.slice(2, 4) - 1;
      let JourDebutPeriode = DebutPeriode.slice(0, 2);

      let DateDebutPeriode = new Date();
      DateDebutPeriode.setFullYear(AnneeDebutPeriode, MoisDebutPeriode, JourDebutPeriode);

      let DateFinPeriode = new Date();
      DateFinPeriode.setFullYear(FinPeriode.slice(4), FinPeriode.slice(2, 4) - 1, FinPeriode.slice(0, 2));

      DateDebutPeriode.setHours(0, 0, 0, 0);
      DateFinPeriode.setHours(24, 0, 0, 0);

      if (DateFinPeriode.getTime() <= DateDebutPeriode.getTime()) {
        setDisableValidate(true);
      } else {
        setDisableValidate(false);
      }
    } else {
      setDisableValidate(true);
    }
  };
  useEffect(() => {
    handleEndGreaterBegin();
    handleMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.RetraiteDebutActivite, context.state.RetraiteFinActivite, context.state.CheckboxDepartRetraite]);

  return (
    <>
      <Pager
        withMenu
        validateDisabled={disableValidate}
        pages={handleMenu()}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
          const menu = handleMenu();
          const selectedPage = menu[page];
          
          // Track events when user navigates to specific tabs
          if (selectedPage && selectedPage.label === "Revenus") {
            trackEvent('PERIODE', 'TAB_REVENUS');
          } else if (selectedPage && selectedPage.label === "Paramètres") {
            trackEvent('PERIODE', 'TAB_PARAMETRES');
          }
        }}
        navButtons={{
          // cancel: {
          //   onClick: () => {
          //     props.onClose();
          //   },
          // },
          previous: {},
          next: {},
          validate: {
            onClick: (evt) => {
              props.onClose();
              context.handleAddPeriodeRetraite(context.state.IdPeriodeRetraite, props.Outil, props.ClientConjoint);
            },
          },
        }}
      />
    </>
  );
};

export default AjoutPeriodeCumulEmploiPageModal;
